import { render } from "./account.vue?vue&type=template&id=6eadb707"
import script from "./account.js?vue&type=script&lang=js&external"
export * from "./account.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__